import { useRef } from 'react';
import { useOutsideBlur } from '../../hooks/useOutsideBlur';
import './style.scss';

type Props<T extends string | boolean> = {
  options: { name: string; value: T }[];
  onChange?: (value: T) => void;
  onBlur?: () => void;
  name: string;
  value?: T;
  disabled?: boolean;
};

export function RadioSelect<T extends string | boolean>({
  options,
  onChange,
  name,
  value,
  onBlur,
  disabled,
}: Props<T>) {
  const wrapper = useRef<HTMLDivElement>(null);
  const { setBlur } = useOutsideBlur(wrapper, () => onBlur?.());
  return (
    <div
      className="tru-radio-select"
      ref={wrapper}
      onBlur={() => setBlur(true)}
    >
      {options.map((option) => (
        <label
          className="radio-button-container"
          key={`tru-radio-option-${option.value}`}
        >
          <input
            type="radio"
            name={name}
            checked={value === option.value}
            onChange={() => onChange?.(option.value)}
            disabled={disabled}
          />
          <span className="radio-button" />
          <span>{option.name}</span>
        </label>
      ))}
    </div>
  );
}
